import { GetDefaultFormatsResponseBody } from '../types/generated/defaultFormats_get.response';
import apiEndpoints from '../../apiEndpoints';
import { fetcher } from '../utils/fetchers/fetcher';

export const requestDefaultFormats = (
  token: string | null,
  forceHeader?: string
): Promise<GetDefaultFormatsResponseBody> =>
  fetcher<GetDefaultFormatsResponseBody>(
    apiEndpoints.routes.defaultFormats,
    'GET',
    token,
    forceHeader
  );
